import React from 'react'
import { PiSignOut } from 'react-icons/pi'
import { useAuth } from 'context/authentication/useAuth'
import { CompanyAvatar } from './CompanyAvatar'

interface ProfileMenuProps {
  onLogout: () => void
}

/**
 * Popover content for the left-nav Profile button. Header row shows the
 * company logo (with initials fallback) alongside the user's name + email;
 * footer row provides the Log out action.
 */
export const ProfileMenu: React.FC<ProfileMenuProps> = ({ onLogout }) => {
  const { user } = useAuth()
  const fullName = `${user?.first_name ?? ''} ${user?.last_name ?? ''}`.trim()

  return (
    <div>
      <div className="flex items-center gap-3 pl-3 pr-12 py-2.5">
        <CompanyAvatar size={40} transparentBg />
        <div className="flex flex-col gap-0.5 min-w-0">
          {fullName && (
            <p className="m-0 text-sm font-semibold text-fg leading-5 truncate">
              {fullName}
            </p>
          )}
          <p className="m-0 text-xs text-fg-secondary leading-5 break-all">
            {user?.email}
          </p>
        </div>
      </div>
      <div className="border-t border-line" />
      <div className="px-2 py-1.5" data-popover-menu>
        <button
          type="button"
          onClick={onLogout}
          className="group flex items-center gap-3 w-full px-3 py-[10px] bg-transparent border-0 rounded-lg cursor-pointer outline-none text-left transition-colors"
        >
          <PiSignOut
            size={16}
            className="text-neutral-700 group-hover:text-neutral-800"
          />
          <span className="text-sm font-medium tracking-[-0.2px] text-neutral-700 group-hover:text-neutral-800">
            Log out
          </span>
        </button>
      </div>
    </div>
  )
}
